module.exports = __webpack_public_path__ + "static/img/loading.4bd883e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading.gif
// module id = 118
// module chunks = 7